export type MedicationStatus = 'IN_USE' | 'INTERRUPTED' | 'NOT_APPLICABLE'
export type DiagnosticStatus = 'REFERRED' | 'HYPOTHESIS' | 'CONFIRMED' | 'DONE'
export enum PatientGoalType {
  ACTION = 'ACTION',
  PRE_CONTEMPLATION = 'PRE_CONTEMPLATION',
  CONTEMPLATION = 'CONTEMPLATION',
  PLANNING_OR_PREPARATION = 'PLANNING_OR_PREPARATION',
  MAINTENANCE_OR_RELAPSE = 'MAINTENANCE_OR_RELAPSE',
}
export enum MedicalRecordFormType {
  TECHNICAL_EVALUATION = 'TECHNICAL_EVALUATION',
  EVOLUTION = 'EVOLUTION',
  OUTCOME = 'OUTCOME',
}

export type MedicalRecordFile = {
  original_name: string
  size: number
  uuid: string
  url?: string
}

export type PatientCaseComplexityType = 'NORMAL' | 'LOW' | 'MODERATE' | 'SERIOUS'

export interface MedicalRecordPayload {
  complaints: {
    id: number
    ciap_code: string
    description: string
  }[]
  symptoms: {
    id: number
    description: string
  }[]
  medications: {
    id: number
    status: MedicationStatus
    commercial_name: string
    generic_name: string
  }[]
  diagnostic_hypotheses: {
    id: number
    status: DiagnosticStatus
    cid_code: string
    description: string
  }[]
  patient_needs_to_continue_treatment: {
    number_of_schedules: string
    reason: string
    other_reason?: string
    need_to_continue_treatment: boolean
  }
  other_complaint: {
    description: string
  }
  other_symptom: {
    description: string
  }
  other_medications: {
    id?: number
    description: string
    status: MedicationStatus
  }[]
  other_patient_consumption: {
    description: string
  }
  patient_consumptions: string[]
  symptoms_impact_on_work_life: string
  has_suicidal_ideation: boolean
  has_psychiatrist_treatment: boolean
  patient_goal: PatientGoalType
  patient_case_complexity: string
  last_patient_case_complexity: string
  patient_case_description: string
}

export interface MedicalRecordForm {
    uuid: string
    type: MedicalRecordFormType
    published_at_utc?: string | null
    files: MedicalRecordFile[]
    has_suicidal_ideation: boolean | null
    symptoms_impact_on_work_life: string
    patient_consumptions: string[]
    referral_to_healthcare_professional: string
    has_psychiatrist_treatment: boolean
    patient_goal: PatientGoalType
    patient_case_complexity: PatientCaseComplexityType
    last_patient_case_complexity: PatientCaseComplexityType
    patient_case_description: string
    patient_needs_to_continue_treatment: {
      need_to_continue_treatment: string;
      number_of_schedules: string;
      other_reason: string;
      reason: string;
    };
    other_symptom?: {
      id: number
      description: string
    }
    other_complaint?: {
      id: number
      description: string
    }
    other_medications?: {
      id: number
      commercial_name: string
      status: MedicationStatus
    }[]
    other_patient_consumption?: {
      id: number
      description: string
    }
    symptoms: {
      symptom_medical_record_form_id: number
      symptom: {
        id: number
        description: string
      }
    }[]
    diagnostic_hypotheses: {
      diagnostic_hypothesis_medical_record_form_id: number
      status: DiagnosticStatus
      diagnostic_hypothesis: {
        id: number
        cid_code: string
        description: string
      }
    }[]
    complaints: {
      complaint_medical_record_form_id: number
      complaint: {
        id: number
        ciap_code: string
        description: string
      }
    }[]
    medications: {
      medication_medical_record_form_id?: number
      status: MedicationStatus
      medication: {
        id: number
        commercial_name: string
        generic_name: string
      }
    }[]
}
